<template>
  <div class="tile">
    <MarketReportsMenu  :isEditable="isEditable"
                        :header="header"
                        @edit="handleEdit"
                        @undo="handleUndo"
                        @save="handleSave" />
    <div class="tile-content tile-scrollable table-wrapper">
      <table v-if="kpis && kpis.length > 0">
        <thead>
          <tr>
            <th class="fixed-column" style="min-width: 8rem; width: 20%;"></th>
            <th class="fixed-column" style="min-width: 10rem; width: 40%;"></th>
            <th v-for="(column, index) in getWaveKeys" :key="index"
                class="th-column">{{ getLabel(index) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(kpi, item) in getKpis" 
              :key="item"
              class="tr-row">
            <td class="fixed-column">{{ kpi.alternativeClusterLabel || kpi.cluster }}</td>
            <td class="fixed-column">{{ kpi.alternativeKpiLabel || kpi.kpi }}</td>
            <td v-for="(column, index) in getWaveKeys" :key="index"
                class="data"
                :style="{ 'background': getColor(index) }">
              <div v-if="!brandMode">
                <span>{{ getResult(kpi, index) }}</span>
              </div>
              <div v-else>
                <span style="display: block;">
                  <span class="data-hidden" v-if="getLastWaveIcon(kpi, index) > 0">
                    <font-awesome-icon  :icon="['fas', 'caret-up']"
                                        item-width="24" item-height="36" /> 
                    {{ getResult(kpi, index) }}
                    <span class="sml-text data-hidden">{{ getLastWaveVsResult(kpi, index) }}</span>
                  </span>

                  <span class="data-hidden" v-else-if="getLastWaveIcon(kpi, index) < 0">
                    <font-awesome-icon  :icon="['fas', 'caret-down']"
                                        item-width="24" item-height="36" /> 
                    {{ getResult(kpi, index) }}
                    <span class="sml-text data-hidden">{{ getLastWaveVsResult(kpi, index) }}</span>
                  </span>

                  <span class="data-hidden" v-else-if="getLastWaveIcon(kpi, index) === 0">
                    <font-awesome-icon  :icon="['fas', 'caret-right']"
                                        item-width="24" item-height="36" /> 
                    {{ getResult(kpi, index) }}
                    <span class="sml-text data-hidden">{{ getLastWaveVsResult(kpi, index) }}</span>
                 </span>

                 <span class="data-hidden" v-else-if="getLastWaveIcon(kpi, index) === undefined">
                    <font-awesome-icon  :icon="['fas', 'square']"
                                        item-width="6" item-height="6" /> 
                    {{ getResult(kpi, index) }}
                    <span class="sml-text data-hidden">no hist. data</span>
                 </span>

                  
                  
                  <span class="data-visible">
                    {{ getResult(kpi, index) }}
                  </span>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot></tfoot>
      </table>
      <div v-else class="market-reports-no-data">{{ $t("Webportal.NoData") }}</div>
    </div>
  </div>

</template>

<script>
import MarketReportsMixin from '@/mixins/MarketReportsMixin';

export default {
  mixins: [MarketReportsMixin],
  components: {
  },
  props: {
    brandMode:  { type: Boolean, required: true },
    kpis: { type: Array, required: true },
    waves: { type: Array, required: true },
  },
  data() {
    return {
    };
  },
  computed: {
    getKpis() {
      return [...this.kpis];
    },
    getWaveKeys() {
      if (!this.brandMode)
        return JSON.parse(JSON.stringify(this.waves.map(x => x.id))).reverse();
      return this.waves.map(x => x.id);
    }
  },
  methods: {
    getColor(index) {
      if (this.brandMode)
        return this.waves[index].color;
      return this.waves[this.waves.length - 1 - index].color;
    },

    getLabel(index) {
      if (this.brandMode)
        return this.waves[index]?.label;

      let label = this.waves[this.waves.length - 1 - index]?.label;
      label = label.replace(/_/g, '_\n');
      return label
    },

    getResult(kpi, index) {
      let result = undefined;
      let wave = this.brandMode 
            ? this.waves[index] 
            : this.waves[this.waves.length - 1 - index];
      
      result = kpi.results.find(x => x.key === wave.id)?.value;
      
      if (result === undefined || result === null)
        return this.$t("Webportal.NotAvailable");
      
      return result + '%';
    },

    getLastWaveVsResult(kpi, index) {
      let item = kpi.results[index];
      if (!item || !item?.value || !item?.lastValue)
        return null;
      let result = item.value - item.lastValue;
      let sign = result.toString().startsWith('-') ? '' : '+';
      return `${sign}${result.toString()}% vs. last wave`;
    },

    getLastWaveIcon(kpi, index) {
      let item = kpi.results[index];
      if (!item || !item?.value || !item?.lastValue)
        return undefined;
      return item.value - item.lastValue;
    }
  },
  mounted() {
  },
  beforeDestroy() {
  }
};

</script>

<style scoped lang="scss">

.table-wrapper {
  overflow-x: auto!important;
}
.tr-row {
  height: 4rem;
}
.fixed-column {
  left: 0rem;
  background-color: white;
}
.fixed-column:nth-child(2) {
  background-color: white;
  left: 8rem; /* Breite der ersten Spalte */
}
table { 
  font-size: 13px;
  width: calc(100% - 2rem);
  border-collapse: collapse;
}
thead th {
  padding: 0rem 0.25rem;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: white; /* Ensure the header is not transparent */
  z-index: 1; /* Make sure the header is above other content */
}

td {
  border: 1px solid #ccc;
  padding: 0rem 0.25rem;
  text-align: left;
}

.data {
  font-size: 14px;
  text-align: center;
  width: 8rem;
  color: aliceblue;
  font-weight: bold;
  text-shadow: #444 -1px 1px 1px ;
}
.data:hover .data-hidden {
  display: block;
}

.data-hidden {
  display: none;
}

/* Initially shows the element with .data-visible */
.data-visible {
  display: block;
}

/* Hides the element with .data-visible when hovering over .data */
.data:hover .data-visible {
  display: none;
}

.th-column {
  // max-width: 2rem;
  min-width: 5rem;
}

.sml-text {
  font-stretch: condensed;
  font-size: smaller;
}
</style>